/**
 * Data Joiner — namespaced Vuex store module.
 *
 * Migrated from the standalone efficient-vineyard-data-joiner plugin.
 * The plugin's original `new Vuex.Store(...)` becomes a namespaced
 * module so the original mutations carry over verbatim — inside a
 * namespaced module, mutations are already scoped.
 *
 * Home.vue registers this module on entry and unregisters it on
 * leave, so each visit starts from clean state.
 */
export default {
  namespaced: true,
  state: () => ({
    allHeaders: [],
    allJsonDataArray: [],
    breadcrumbs: [
      { id: 'root', name: 'Root' }
    ],
    chosenDatasets: [],
    datasets: [],
    editMode: false,
    farm: {},
    folder: { id: 'root', name: 'Root' },
    folders: [],
    loadingFolderPicker: false,
    merge: {},
    mergeIndex: false,
    merges: [],
    spinner: false,
    showCreateMerge: false,
    showFolderPicker: false,
    showPreviewExport: false
  }),
  mutations: {
    setStateProperty (state, options) {
      state[options.property] = options.value
    },
    setSpinner (state, boolean) {
      state.spinner = boolean
    },
    setDatasets (state, datasets) {
      state.datasets = datasets
    }
  }
}
